// ============================================================
// THE PLATE'S TYPE - one table for the callouts' words.
//
// The free-spot placement (calloutLayout) measures each word by its type
// size and letter spacing; the plate draws it with the same. Written twice,
// a size changed in the stylesheet would leave the placement fitting words
// of the old size, and nothing would fail. So the sizes live here alone: the
// placement reads them, and each plate's svg carries them as custom
// properties (`plateTypeVars`) that BodyPlate.module.css reads.
//
// Pure. Zero React dependency. Frame units.
// ============================================================

/** Each callout style's type size and letter spacing, in frame units. */
export const PLATE_TYPE = {
  name: { px: 64, spacing: 8 },
  numeral: { px: 150, spacing: 0 },
  tag: { px: 62, spacing: 6 },
  facing: { px: 70, spacing: 8 },
  facingArmour: { px: 130, spacing: 0 },
} as const;

/** A text's drawn box is about this much taller than its type (ascent and descent), as the mock measured it. */
export const TEXT_BOX = 1.15;

/** The table as the custom properties a plate's svg carries: `--type-<style>` and `--type-<style>-spacing`. */
export const PLATE_TYPE_VARS: Readonly<Record<string, string>> = Object.fromEntries(
  Object.entries(PLATE_TYPE).flatMap(([key, { px, spacing }]) => [
    [`--type-${key}`, `${px}px`],
    [`--type-${key}-spacing`, `${spacing}px`],
  ]),
);
